import { computed, Injectable, signal, WritableSignal } from '@angular/core';
import { AppViews } from '@models/enums/dvm/DvmViews.enum';
import { Filter } from '@models/types/app/Filter.type';

@Injectable({
  providedIn: 'root'
})
export class FilterService {

  // FILTERS (signal-based)
  public readonly filter: WritableSignal<Filter> = signal<Filter>({
    section: [],
    row:     [],
    seat:    []
  });

  public readonly hasFilters = computed<boolean>(() => {
    return Object.values(this.filter()).some((value: string[]) => value.length > 0);
  });

  // METHODS
  public getFilterByKey(key: keyof Filter): string[] {
    return this.filter()[key] || [];
  }

  public getFiltersByView(view: AppViews): string[] {
    const f = this.filter();
    switch(view) {

      case AppViews.Topview:
        return f.section;
      
      case AppViews.Seatmap:
        return [f.row, f.seat].flat();
      
      case AppViews.Main:
        return [f.section, f.row, f.seat].flat();
      
      default:
        return [];
    
    }

  }

  public setFilters(view: keyof Filter, availability: string[]): void {
    this.filter.update(current => ({ ...current, [view]: availability }));
  }

  public clearFilters(): void {
    this.filter.set({ section: [], row: [], seat: [] });
  }

}
